@if (!this.projectService.selectedProject && this.loginService.loggedInUser!.orgShorts.length > 1) {
<div>
  <p-select
    [options]="loginService.getMyOrgSorted()"
    [(ngModel)]="this.projectService.searchOrgShort"
    (ngModelChange)="this.onOrgChange($event)"
    placeholder="Mandant auswählen"
    i18n-placeholder="@@select-organization-placeholder"
    [showClear]="true"
    class="w-full"
    id="organization"
  >
  </p-select>
</div>
}